const dist = require('./dist/');
module.exports = {
  authorization: dist.authorization,
  currentUser: dist.currentUser,
  legit: dist.legit,
  session: dist.session,
  verify: dist.verify,
  legitSagas: dist.legitSagas,
  legitReducers: dist.legitReducers,
};

